// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schoolStructure {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding-bottom: 32px;
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);
}

.schoolStructure-head {
  display: flex;
  width: calc(100% + 48px);
  height: 70px;
  min-height: 70px;
  align-items: center;
  gap: 28px;
  margin: -20px 0 18px -24px;
  padding: 0 72px 0 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.schoolStructure-head h1 {
  flex: 0 0 auto;
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, inherit);
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.015em;
  line-height: 1.1;
  white-space: nowrap;
}

.schoolStructure-tabs {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  align-self: stretch;
  align-items: center;
  gap: 26px;
  margin: 0;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
}

.schoolStructure-tabs::-webkit-scrollbar {
  display: none;
}

.schoolStructure-tab {
  position: relative;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  height: 100%;
  padding: 1px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 14px;
  font-weight: 650;
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.15s ease;
}

.schoolStructure-tab:hover {
  color: var(--text-strong, #0f172a);
  text-decoration: none;
  background: transparent;
}

.schoolStructure-tab--active,
.schoolStructure-tab--active:hover {
  color: var(--blue-600, #1a6da3);
  background: transparent;
  font-weight: 700;
}

.schoolStructure-tab--active::after {
  content: '';
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: var(--action-primary, #227ebd);
}

.schoolStructure-content {
  min-width: 0;
  padding: 16px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));
}

.schoolStructure-content--forms {
  padding: 0;
  overflow: visible;
}

.schoolStructure-content--forms .schoolStructure-toolbar {
  margin: 0;
  padding: 14px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}

.schoolStructure-content--forms .schoolStructure-selection {
  margin: 12px 16px;
}

.schoolStructure-content--forms .schoolStructure-tableCard {
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

.schoolStructure-content--forms .schoolStructure-pagination {
  margin: 0;
  padding: 12px 16px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.schoolStructure-content > .mt-3 {
  margin-top: 0 !important;
}

.schoolStructure-content .row {
  margin-left: 0;
  margin-right: 0;
}

.schoolStructure-content .col-md-12 {
  padding-left: 0;
  padding-right: 0;
}

.schoolStructure-content .table-responsive {
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
}

.schoolStructure-content table.table {
  margin-top: 0 !important;
  margin-bottom: 0;
  color: var(--text-body, #334155);
  font-size: 13px;
}

.schoolStructure-content table.table thead th {
  border-top: 0;
  border-bottom-color: var(--border-subtle, #e2e8f0);
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: var(--surface-sunken, #f1f5f9);
}

.schoolStructure-content table.table tbody td {
  border-top-color: var(--border-subtle, #e2e8f0);
  vertical-align: middle;
}

.schoolStructure-content .btn.btn-primary,
.schoolStructure-content .btn.btn-secondary,
.schoolStructure-content .btn.btn-danger {
  min-height: 34px;
  border-radius: var(--radius-sm, 6px);
  font-size: 13px;
  font-weight: 700;
  box-shadow: none;
}

.schoolStructure-content .btn.btn-primary {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
}

@media (max-width: 1217px) {
  .schoolStructure-head {
    width: calc(100% + 24px);
    margin: -16px 0 18px -12px;
    padding-right: 28px;
  }
}

@media (max-width: 768px) {
  .schoolStructure {
    padding-bottom: 24px;
  }

  .schoolStructure-head {
    width: calc(100% + 24px);
    height: auto;
    min-height: 70px;
    flex-wrap: wrap;
    gap: 0 16px;
    margin: -16px 0 14px -12px;
    padding: 10px 16px 0;
  }

  .schoolStructure-head h1 {
    overflow: hidden;
    font-size: 20px;
    text-overflow: ellipsis;
  }

  .schoolStructure-tabs {
    width: 100%;
    height: 42px;
    flex: 1 0 100%;
    order: 3;
    gap: 22px;
  }

  .schoolStructure-content {
    padding: 12px;
  }

  .schoolStructure-content--forms {
    padding: 0;
  }
}
.schoolStructure-listActions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 12px;
}

.schoolStructure-primaryActions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.schoolStructure-btn {
  min-height: 36px;
  padding: 0 13px;
  border-radius: var(--radius-md, 8px);
  border: 1px solid var(--border-default, #cbd5e1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
  cursor: pointer;
  box-shadow: none;
}

.schoolStructure-btn:disabled {
  opacity: 0.48;
  cursor: default;
}

.schoolStructure-btn--primary {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.schoolStructure-btn--primary:hover:not(:disabled) {
  border-color: var(--action-primary-hover, #1a6da3);
  background: var(--action-primary-hover, #1a6da3);
}

.schoolStructure-btn--secondary {
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
}

.schoolStructure-btn--secondary:hover:not(:disabled) {
  border-color: var(--border-strong, #94a3b8);
  background: var(--surface-hover, #f8fafc);
}

.schoolStructure-btn--danger {
  border-color: transparent;
  background: var(--red-500, #da4453);
  color: #fff;
}

.schoolStructure-btn--danger:hover:not(:disabled) {
  background: var(--red-600, #c4313f);
  box-shadow: 0 4px 12px rgba(218, 68, 83, 0.28);
}

.schoolStructure-selection {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  flex-wrap: wrap;
  min-height: 0;
  padding: 8px 14px;
  border: 1px solid var(--blue-100, #d4e8f6);
  border-radius: var(--radius-md, 8px);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: var(--text-sm, 13px);
}

.schoolStructure-selection__summary {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  color: var(--blue-700, #155d8c);
  font-size: var(--text-sm, 13px);
  font-weight: var(--weight-semibold, 600);
  white-space: nowrap;
}

.schoolStructure-selection__actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.schoolStructure-selection .schoolStructure-btn {
  min-height: var(--control-h-sm, 32px);
  height: var(--control-h-sm, 32px);
  padding: 0 11px;
  font-size: var(--text-sm, 13px);
  font-weight: var(--weight-semibold, 600);
}

.schoolStructure-selection__clear {
  border: none;
  background: transparent;
  color: var(--text-link, #1a6da3);
  padding: 0;
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: var(--text-sm, 13px);
  font-weight: var(--weight-semibold, 600);
  cursor: pointer;
  white-space: nowrap;
}

.schoolStructure-selection__clear:hover {
  text-decoration: underline;
}

.schoolStructure-content .bActionsButton {
  display: none !important;
}

@media (max-width: 560px) {
  .schoolStructure-primaryActions,
  .schoolStructure-selection,
  .schoolStructure-selection__actions,
  .schoolStructure-btn {
    width: 100%;
  }
}

.schoolStructure-drawerScrim {
  position: fixed;
  inset: 0;
  z-index: 1040;
  background: rgba(15, 23, 42, 0.28);
}

.schoolStructure-drawer {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1041;
  display: flex;
  flex-direction: column;
  width: min(520px, calc(100vw - 32px));
  height: 100vh;
  background: var(--surface-card, #fff);
  border-left: 1px solid var(--border-subtle, #e2e8f0);
  box-shadow: -18px 0 36px rgba(15, 23, 42, 0.18);
}

.schoolStructure-drawer--wide {
  width: min(760px, calc(100vw - 32px));
}

.schoolStructure-drawer__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px 18px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.schoolStructure-drawer__eyebrow {
  margin-bottom: 5px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.schoolStructure-drawer__head h2 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-size: 22px;
  font-weight: 800;
  line-height: 1.2;
}

.schoolStructure-drawer__head p {
  margin: 6px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  line-height: 1.4;
}

.schoolStructure-drawer__close {
  width: 34px;
  height: 34px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-sm, 6px);
  background: var(--surface-card, #fff);
  color: var(--text-muted, #64748b);
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.schoolStructure-drawer__close:hover {
  color: var(--text-strong, #0f172a);
  background: var(--surface-hover, #f8fafc);
}

.schoolStructure-drawer__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding: 20px 24px 24px;
}

.schoolStructure-drawer__body .container-fluid,
.schoolStructure-drawer__body .row,
.schoolStructure-drawer__body .col-md-12 {
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;
  margin-right: 0;
}

.schoolStructure-drawer__body label {
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 700;
}

.schoolStructure-content tbody tr {
  cursor: pointer;
}

@media (max-width: 560px) {
  .schoolStructure-drawer,
  .schoolStructure-drawer--wide {
    width: 100vw;
  }

  .schoolStructure-drawer__head {
    padding: 18px 16px 14px;
  }

  .schoolStructure-drawer__body {
    padding: 16px;
  }
}

.schoolStructure-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.schoolStructure-toolbar__heading {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.schoolStructure-toolbar__heading h2 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, inherit);
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1.2;
}

.schoolStructure-toolbar__heading span {
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  border-radius: var(--radius-pill, 999px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 800;
}

.schoolStructure-toolbar__controls {
  display: flex;
  align-items: end;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.schoolStructure-toolbar__spacer {
  flex: 1 1 auto;
}

.schoolStructure-search {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin: 0;
}

.schoolStructure-search span {
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.schoolStructure-search input {
  width: 240px;
  height: var(--control-h-md, 40px);
  min-width: 0;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  color: var(--text-strong, #0f172a);
  padding: 0 12px;
  font-size: 13px;
  box-shadow: none;
}

.schoolStructure-search input:focus {
  outline: none;
  border-color: var(--border-brand, #6fb1df);
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.12);
}

.schoolStructure-btn--active {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.schoolStructure-buttonIcon {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  display: inline-block;
  background: currentColor;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: 16px 16px;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  -webkit-mask-size: 16px 16px;
}

.schoolStructure-buttonIcon--filter {
  mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E");
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E");
}

.schoolStructure-filterBtn {
  min-height: var(--control-h-md, 40px);
  height: var(--control-h-md, 40px);
  padding-left: 11px;
}

.schoolStructure-clearFilters {
  min-height: var(--control-h-md, 40px);
  padding: 0 6px;
  border: 0;
  background: transparent;
  color: var(--text-link, #1a6da3);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.schoolStructure-clearFilters:hover {
  text-decoration: underline;
}

.schoolStructure-selectMenu {
  position: relative;
}

.schoolStructure-selectMenu__menu {
  right: 0;
  left: auto;
  display: flex;
  flex-direction: column;
}

.schoolStructure-tableCard {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));
}

.schoolStructure-tableScroll {
  width: 100%;
  overflow-x: auto;
}

.schoolStructure-table {
  width: 100%;
  min-width: 720px;
  border-collapse: separate;
  border-spacing: 0;
}

.schoolStructure-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 11px 14px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--slate-50, #f8fafc);
  color: var(--text-muted, #64748b);
  text-align: left;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  white-space: nowrap;
}

.schoolStructure-table td {
  padding: 12px 14px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  color: var(--text-body, #334155);
  font-size: 13px;
  vertical-align: middle;
}

.schoolStructure-table tbody tr {
  cursor: pointer;
  transition: background 0.12s ease;
}

.schoolStructure-table tbody tr:hover,
.schoolStructure-table tbody tr[data-preview='true'] {
  background: var(--slate-50, #f8fafc);
}

.schoolStructure-table tbody tr[data-selected='true'] {
  background: var(--blue-50, #eef6fc);
}

.schoolStructure-table tbody tr[data-preview='true'] td:first-child {
  box-shadow: inset 3px 0 0 var(--action-primary, #227ebd);
}

.schoolStructure-table tbody tr:last-child td {
  border-bottom: 0;
}

.schoolStructure-table__check {
  width: 42px;
  padding-right: 4px !important;
}

.schoolStructure-table__check input,
.schoolStructure-cardCheck input {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: var(--action-primary, #227ebd);
}

.schoolStructure-table__sortable {
  cursor: pointer;
}

.schoolStructure-rowTitle {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--text-strong, #0f172a);
  font-weight: 700;
}

.schoolStructure-formIcon {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 17px;
  line-height: 1;
}

.schoolStructure-formIcon::before {
  content: '';
  width: 17px;
  height: 17px;
  background: currentColor;
  mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9m-6-6 6 6m-6-6v6h6M8 13h8M8 17h6' fill='none' stroke='black' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: contain;
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9m-6-6 6 6m-6-6v6h6M8 13h8M8 17h6' fill='none' stroke='black' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  -webkit-mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: contain;
}

.schoolStructure-badge {
  min-height: 24px;
  padding: 0 9px;
  border-radius: var(--radius-pill, 999px);
  display: inline-flex;
  align-items: center;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 700;
}

.schoolStructure-mutedText {
  color: var(--text-muted, #64748b);
}

.schoolStructure-empty {
  height: 132px;
  text-align: center;
  color: var(--text-muted, #64748b);
}

.schoolStructure-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 12px;
}

.schoolStructure-pagination__summary {
  margin-right: 4px;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  font-weight: 600;
}

.schoolStructure-pagination__ellipsis {
  color: var(--text-muted, #64748b);
  font-size: 13px;
}

.schoolStructure-pageBtn {
  min-width: 34px;
  height: 34px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-sm, 6px);
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.schoolStructure-pageBtn--active {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.schoolStructure-houseGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(268px, 1fr));
  gap: 16px;
}

.schoolStructure-houseCard {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));
  cursor: pointer;
  transition: box-shadow 0.15s ease, transform 0.15s ease, border-color 0.15s ease;
}

.schoolStructure-houseCard:hover,
.schoolStructure-houseCard[data-preview='true'] {
  border-color: var(--border-brand, #6fb1df);
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.12);
  transform: translateY(-2px);
}

.schoolStructure-houseCard[data-selected='true'] {
  border-color: var(--blue-200, #b7dbf2);
  background: var(--blue-50, #eef6fc);
}

.schoolStructure-houseCard__stripe {
  height: 6px;
}

.schoolStructure-houseCard__body {
  padding: 18px 18px 16px;
}

.schoolStructure-houseCard__top {
  display: flex;
  align-items: center;
  gap: 13px;
}

.schoolStructure-houseCard__title {
  flex: 1 1 auto;
  min-width: 0;
}

.schoolStructure-houseCard__title h3 {
  margin: 0 0 5px;
  color: var(--text-strong, #0f172a);
  font-size: 17px;
  font-weight: 800;
  line-height: 1.2;
}

.schoolStructure-houseCard p {
  min-height: 42px;
  margin: 13px 0 16px;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  line-height: 1.55;
}

.schoolStructure-houseCrest {
  flex: 0 0 auto;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.08);
}

.schoolStructure-houseCrest--initial {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 800;
  font-size: 18px;
  text-transform: uppercase;
}

.schoolStructure-colours {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.schoolStructure-colours i {
  width: 13px;
  height: 13px;
  border-radius: 50%;
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.12);
}

.schoolStructure-cardCheck {
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.schoolStructure-houseCard__stats {
  display: flex;
  gap: 20px;
  padding-top: 14px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.schoolStructure-houseCard__stats div {
  min-width: 0;
}

.schoolStructure-houseCard__stats strong {
  display: block;
  color: var(--text-strong, #0f172a);
  font-size: 19px;
  font-weight: 800;
  line-height: 1.2;
}

.schoolStructure-houseCard__stats span {
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
}

.schoolStructure-emptyCard {
  padding: 40px 20px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #fff);
  text-align: center;
}

.schoolStructure-emptyCard__icon {
  width: 46px;
  height: 46px;
  margin: 0 auto 12px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 22px;
}

.schoolStructure-emptyCard__icon::before {
  content: '';
  width: 22px;
  height: 22px;
  background: currentColor;
  mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m3 11 9-7 9 7M5 10v10h14V10M9 20v-6h6v6' fill='none' stroke='black' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: contain;
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m3 11 9-7 9 7M5 10v10h14V10M9 20v-6h6v6' fill='none' stroke='black' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  -webkit-mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: contain;
}

.schoolStructure-emptyCard h3 {
  margin: 0 0 6px;
  color: var(--text-strong, #0f172a);
  font-size: 17px;
  font-weight: 800;
}

.schoolStructure-emptyCard p {
  margin: 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
}

@media (max-width: 760px) {
  .schoolStructure-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .schoolStructure-toolbar__controls,
  .schoolStructure-search,
  .schoolStructure-search input {
    width: 100%;
  }

  .schoolStructure-toolbar__controls .schoolStructure-btn,
  .schoolStructure-selectMenu {
    width: 100%;
  }

  .schoolStructure-pagination {
    justify-content: flex-start;
  }
}

.schoolStructure-overview {
  display: grid;
  grid-template-columns: repeat(4, minmax(140px, 1fr));
  gap: 12px;
  margin: 0 0 14px;
}

.schoolStructure-overviewCard {
  min-height: 76px;
  padding: 14px 16px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-xs, 0 1px 2px rgba(15, 23, 42, 0.06));
}

.schoolStructure-overviewCard--primary {
  border-color: var(--blue-100, #d4e8f6);
  background: linear-gradient(180deg, var(--blue-50, #eef6fc) 0%, var(--surface-card, #fff) 100%);
}

.schoolStructure-overviewCard span {
  display: block;
  margin-bottom: 7px;
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.schoolStructure-overviewCard strong {
  display: block;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, inherit);
  font-size: 24px;
  font-weight: 800;
  line-height: 1.1;
}

.schoolStructure-rowTitle__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.schoolStructure-rowTitle__text strong {
  color: var(--text-strong, #0f172a);
  font-size: 13.5px;
  font-weight: 800;
  line-height: 1.2;
}

.schoolStructure-rowTitle__text small {
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
  font-weight: 600;
  line-height: 1.25;
}

.schoolStructure-countPill {
  min-height: 26px;
  padding: 0 10px;
  border: 1px solid var(--green-200, #b9e7d0);
  border-radius: var(--radius-pill, 999px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--green-50, #ecfdf3);
  color: var(--green-700, #16794a);
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.schoolStructure-countPill--muted {
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--slate-50, #f8fafc);
  color: var(--text-muted, #64748b);
}

.schoolStructure-badge--age {
  border: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--slate-0, #fff);
}

.schoolStructure-drawer--form {
  width: min(560px, calc(100vw - 32px));
}

.schoolStructure-drawer__head--rich {
  align-items: flex-start;
  background: linear-gradient(180deg, var(--slate-25, #f8fafc) 0%, var(--surface-card, #fff) 100%);
}

.schoolStructure-drawer__leadIcon {
  flex: 0 0 auto;
  margin-top: 2px;
}

.schoolStructure-drawer__leadIcon .schoolStructure-formIcon {
  width: 44px;
  height: 44px;
  border-radius: var(--radius-md, 8px);
  background: var(--blue-50, #eef6fc);
  color: var(--action-primary, #227ebd);
  font-size: 20px;
  box-shadow: inset 0 0 0 1px var(--blue-100, #d4e8f6);
}

.schoolStructure-detailStats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 16px;
}

.schoolStructure-detailStat {
  min-height: 74px;
  padding: 12px 14px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  background: var(--slate-25, #f8fafc);
}

.schoolStructure-detailStat span {
  display: block;
  margin-bottom: 7px;
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.schoolStructure-detailStat strong {
  display: block;
  color: var(--text-strong, #0f172a);
  font-size: 17px;
  font-weight: 800;
  line-height: 1.2;
}

.schoolStructure-formPanel {
  padding: 16px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-xs, 0 1px 2px rgba(15, 23, 42, 0.06));
}

.schoolStructure-formPanel__title {
  margin-bottom: 14px;
  color: var(--text-strong, #0f172a);
  font-size: 15px;
  font-weight: 800;
}

.schoolFormForm--ds {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.schoolFormForm__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.schoolFormForm__field {
  margin: 0;
}

.schoolFormForm__field label {
  display: block;
  margin: 0 0 4px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: none;
}

.schoolFormForm__field .form-control {
  height: 36px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  color: var(--text-strong, #0f172a);
  font-size: 13px;
  box-shadow: none;
}

.schoolFormForm__field .form-control:focus {
  border-color: var(--border-brand, #6fb1df);
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.12);
}

.schoolFormForm__ageGroups {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
  padding: 7px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
}

.schoolFormForm__ageGroups.is-invalid {
  border-color: var(--danger, #dc3545);
}

.schoolFormForm__ageSection {
  min-width: 0;
  padding: 6px;
  border-radius: var(--radius-sm, 6px);
  background: var(--slate-50, #f8fafc);
}

.schoolFormForm__ageSection > strong {
  display: block;
  margin-bottom: 5px;
  color: var(--text-muted, #64748b);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.04em;
  line-height: 1.2;
  text-transform: uppercase;
}

.schoolFormForm__ageChips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.schoolFormForm__ageChip {
  min-height: 27px;
  padding: 3px 9px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 999px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}

.schoolFormForm__ageChip:hover {
  border-color: var(--border-brand, #6fb1df);
  background: var(--surface-hover, #f8fafc);
}

.schoolFormForm__ageChip--selected {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
  box-shadow: none;
}

.schoolFormForm__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 0;
}

.schoolStructure-modal--form .modal-header {
  padding: 12px 16px !important;
}

.schoolStructure-modal--form .modal-body {
  padding: 14px 16px !important;
}

@media (max-width: 760px) {
  .schoolStructure-overview {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 520px) {
  .schoolStructure-overview,
  .schoolStructure-detailStats {
    grid-template-columns: 1fr;
  }

  .schoolFormForm__actions {
    flex-direction: column-reverse;
  }

  .schoolFormForm__ageGroups {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .schoolFormForm__actions .schoolStructure-btn {
    width: 100%;
  }
}

.schoolStructure-toolbar--inlineFilters {
  align-items: flex-start;
}

.schoolStructure-toolbar__titleControls {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  flex-wrap: wrap;
  min-width: 0;
}

.schoolStructure-filterCount {
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--brand-100, #d9eefb);
  color: var(--brand-700, #17679e);
  font-size: 11px;
  font-weight: 800;
}

.schoolStructure-drawer--filters {
  width: min(440px, calc(100vw - 32px));
}

.schoolStructure-filterFooter {
  justify-content: space-between;
}

.schoolStructure-filterSections {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.schoolStructure-filterSections .people-chipFilter + .people-chipFilter {
  padding-top: 18px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

/* The drawer body owns vertical scrolling. Filter option groups must expand in
   normal document flow so users never get a scrollbar inside a scrollbar. */
.schoolStructure-filterSections .people-chipFilter__body {
  max-height: none;
  overflow: visible;
}

.schoolStructure-content .people-filterChips {
  display: flex;
  min-height: 43px;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin: -2px 0 14px;
  padding: 8px 12px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
}

.schoolStructure-content .people-filterChips > span {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 4px;
  padding: 0 9px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 12px;
}

.schoolStructure-content .people-filterChips > span b {
  font-weight: 800;
}

.schoolStructure-content .people-filterChips > span button,
.schoolStructure-content .people-filterChips__clear {
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font-weight: 800;
  cursor: pointer;
}

.schoolStructure-content .people-filterChips > span button {
  margin-left: 3px;
  font-size: 16px;
  line-height: 1;
}

.schoolStructure-content .people-filterChips__clear {
  margin-left: 2px;
  color: var(--blue-700, #155d8c);
  font-size: 12px;
}

.schoolStructure-search--compact input {
  width: 210px;
}

.schoolStructure-formPanel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.schoolStructure-formPanel__header .schoolStructure-formPanel__title {
  margin-bottom: 0;
}

.schoolStructure-warningModal {
  display: flex;
  gap: 11px;
  align-items: flex-start;
  white-space: normal;
}

.schoolStructure-warningModal__icon {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  border-radius: var(--radius-sm, 6px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--amber-50, #fffbeb);
  color: var(--amber-700, #a16207);
  font-size: 15px;
  font-weight: 900;
  box-shadow: inset 0 0 0 1px var(--amber-200, #fde68a);
}

.schoolStructure-warningModal--danger .schoolStructure-warningModal__icon {
  background: var(--red-50, #fff1f2);
  color: var(--red-600, #c4313f);
  box-shadow: inset 0 0 0 1px var(--red-100, #ffd5da);
}

.schoolStructure-warningModal h3 {
  margin: 0 0 6px;
  color: var(--text-strong, #0f172a);
  font-size: 16px;
  font-weight: 800;
}

.schoolStructure-warningModal p {
  margin: 0;
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 500;
  line-height: 1.45;
}

.schoolStructure-modal--warning .modal-header {
  padding: 13px 16px !important;
}

.schoolStructure-modal--warning .modal-header button {
  width: 32px !important;
  height: 32px !important;
  border-radius: 8px !important;
}

.schoolStructure-modal--warning .modal-body {
  padding: 15px 16px !important;
}

.schoolStructure-modal--warning .modal-footer {
  padding: 10px 16px !important;
}

.schoolStructure-modal--warning .modal-footer .btn {
  min-height: 34px !important;
  padding: 0 13px !important;
  border-radius: var(--radius-md, 8px) !important;
  font-size: 13px;
  font-weight: 700;
}

.schoolStructure-modal--danger .modal-footer .btn-primary {
  border-color: var(--red-500, #da4453) !important;
  background: var(--red-500, #da4453) !important;
  color: #fff !important;
}

.schoolStructure-modal--danger .modal-footer .btn-primary:hover {
  border-color: var(--red-600, #c4313f) !important;
  background: var(--red-600, #c4313f) !important;
}

.schoolStructure-drawer--house {
  width: min(560px, calc(100vw - 32px));
}

.schoolStructure-drawer__footer {
  display: flex;
  gap: 10px;
  padding: 14px 22px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--slate-25, #f8fafc);
}

.schoolStructure-drawer__footer .schoolStructure-btn {
  flex: 1 1 auto;
}

.houseFormDs {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.houseFormDs__crestBlock {
  display: flex;
  align-items: center;
  gap: 14px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}

.houseFormDs__crest {
  width: 82px;
  height: 82px;
  border-radius: var(--radius-lg, 12px);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: var(--slate-50, #f8fafc);
  box-shadow: inset 0 0 0 1px var(--border-subtle, #e2e8f0);
}

.houseFormDs__crest img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.houseFormDs__crest span {
  color: var(--text-muted, #64748b);
  font-size: 28px;
  font-weight: 800;
}

.houseFormDs__crestActions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.houseFormDs__file {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.houseFormDs__textarea {
  min-height: 88px;
  padding-top: 10px;
  resize: vertical;
}

.houseFormDs__colours {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 16px 0;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}

.houseFormDs__label {
  margin-bottom: 8px;
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.houseFormDs__swatches {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.houseFormDs__swatch {
  width: 34px;
  height: 34px;
  border-radius: var(--radius-md, 8px);
  border: 2px solid transparent;
  cursor: pointer;
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.16);
}

.houseFormDs__swatch--selected {
  border-color: var(--text-strong, #0f172a);
}

.houseFormDs__customColour {
  height: 34px;
  padding: 0 8px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.houseFormDs__customColour input {
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}

@media (max-width: 760px) {
  .schoolStructure-toolbar__titleControls,
  .schoolStructure-toolbar__titleControls .schoolStructure-search,
  .schoolStructure-search--compact input {
    width: 100%;
  }

  .houseFormDs__colours {
    grid-template-columns: 1fr;
  }

  .schoolStructure-drawer__footer {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/AdminConsole/SchoolStructure/SchoolStructureRouting.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,8FAA8F;AAChG;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,sBAAsB;EACtB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,SAAS;EACT,kCAAkC;EAClC,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,+BAA+B;EAC/B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;EACrC,8DAA8D;AAChE;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;;;EAGE,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,gDAAgD;EAChD,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mEAAmE;EACnE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,kDAAkD;EAClD,gDAAgD;AAClD;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,0CAA0C;EAC1C,oCAAoC;EACpC,mCAAmC;EACnC,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,+BAA+B;EAC/B,+BAA+B;EAC/B,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,UAAU;EACV,mEAAmE;EACnE,+BAA+B;EAC/B,wCAAwC;EACxC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;;;;IAIE,WAAW;EACb;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,aAAa;EACb,qCAAqC;EACrC,oDAAoD;EACpD,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,oCAAoC;EACpC,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,uBAAuB;AACzB;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;;IAEE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,YAAY;EACZ,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;EACrC,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,8MAA8M;EAC9M,sNAAsN;AACxN;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,mEAAmE;EACnE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;EACrC,8DAA8D;AAChE;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,kBAAkB;EAClB,sDAAsD;EACtD,oCAAoC;EACpC,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,sTAAsT;EACtT,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,8TAA8T;EAC9T,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;EACrC,8DAA8D;EAC9D,eAAe;EACf,gFAAgF;AAClF;;AAEA;;EAEE,0CAA0C;EAC1C,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,oQAAoQ;EACpQ,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,4QAA4Q;EAC5Q,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;;IAGE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;EAC/C,oCAAoC;EACpC,qCAAqC;EACrC,8DAA8D;AAChE;;AAEA;EACE,sCAAsC;EACtC,+FAA+F;AACjG;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,+CAA+C;EAC/C,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,gGAAgG;AAClG;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,mCAAmC;EACnC,qCAAqC;EACrC,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;EAC/C,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,oCAAoC;EACpC,qCAAqC;EACrC,8DAA8D;AAChE;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;EACrC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,YAAY;EACZ,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;EAChD,oBAAoB;EACpB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;4EAC4E;AAC5E;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,+CAA+C;EAC/C,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mDAAmD;EACnD,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mDAAmD;EACnD,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,6BAA6B;EAC7B,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gDAAgD;EAChD,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE;;;IAGE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".schoolStructure {\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  padding-bottom: 32px;\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);\n}\n\n.schoolStructure-head {\n  display: flex;\n  width: calc(100% + 48px);\n  height: 70px;\n  min-height: 70px;\n  align-items: center;\n  gap: 28px;\n  margin: -20px 0 18px -24px;\n  padding: 0 72px 0 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.schoolStructure-head h1 {\n  flex: 0 0 auto;\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, inherit);\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: -0.015em;\n  line-height: 1.1;\n  white-space: nowrap;\n}\n\n.schoolStructure-tabs {\n  display: flex;\n  min-width: 0;\n  flex: 1 1 auto;\n  align-self: stretch;\n  align-items: center;\n  gap: 26px;\n  margin: 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: none;\n}\n\n.schoolStructure-tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.schoolStructure-tab {\n  position: relative;\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  height: 100%;\n  padding: 1px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 14px;\n  font-weight: 650;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: color 0.15s ease;\n}\n\n.schoolStructure-tab:hover {\n  color: var(--text-strong, #0f172a);\n  text-decoration: none;\n  background: transparent;\n}\n\n.schoolStructure-tab--active,\n.schoolStructure-tab--active:hover {\n  color: var(--blue-600, #1a6da3);\n  background: transparent;\n  font-weight: 700;\n}\n\n.schoolStructure-tab--active::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 3px;\n  border-radius: 3px 3px 0 0;\n  background: var(--action-primary, #227ebd);\n}\n\n.schoolStructure-content {\n  min-width: 0;\n  padding: 16px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));\n}\n\n.schoolStructure-content--forms {\n  padding: 0;\n  overflow: visible;\n}\n\n.schoolStructure-content--forms .schoolStructure-toolbar {\n  margin: 0;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.schoolStructure-content--forms .schoolStructure-selection {\n  margin: 12px 16px;\n}\n\n.schoolStructure-content--forms .schoolStructure-tableCard {\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.schoolStructure-content--forms .schoolStructure-pagination {\n  margin: 0;\n  padding: 12px 16px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.schoolStructure-content > .mt-3 {\n  margin-top: 0 !important;\n}\n\n.schoolStructure-content .row {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.schoolStructure-content .col-md-12 {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.schoolStructure-content .table-responsive {\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n}\n\n.schoolStructure-content table.table {\n  margin-top: 0 !important;\n  margin-bottom: 0;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n}\n\n.schoolStructure-content table.table thead th {\n  border-top: 0;\n  border-bottom-color: var(--border-subtle, #e2e8f0);\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  background: var(--surface-sunken, #f1f5f9);\n}\n\n.schoolStructure-content table.table tbody td {\n  border-top-color: var(--border-subtle, #e2e8f0);\n  vertical-align: middle;\n}\n\n.schoolStructure-content .btn.btn-primary,\n.schoolStructure-content .btn.btn-secondary,\n.schoolStructure-content .btn.btn-danger {\n  min-height: 34px;\n  border-radius: var(--radius-sm, 6px);\n  font-size: 13px;\n  font-weight: 700;\n  box-shadow: none;\n}\n\n.schoolStructure-content .btn.btn-primary {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n}\n\n@media (max-width: 1217px) {\n  .schoolStructure-head {\n    width: calc(100% + 24px);\n    margin: -16px 0 18px -12px;\n    padding-right: 28px;\n  }\n}\n\n@media (max-width: 768px) {\n  .schoolStructure {\n    padding-bottom: 24px;\n  }\n\n  .schoolStructure-head {\n    width: calc(100% + 24px);\n    height: auto;\n    min-height: 70px;\n    flex-wrap: wrap;\n    gap: 0 16px;\n    margin: -16px 0 14px -12px;\n    padding: 10px 16px 0;\n  }\n\n  .schoolStructure-head h1 {\n    overflow: hidden;\n    font-size: 20px;\n    text-overflow: ellipsis;\n  }\n\n  .schoolStructure-tabs {\n    width: 100%;\n    height: 42px;\n    flex: 1 0 100%;\n    order: 3;\n    gap: 22px;\n  }\n\n  .schoolStructure-content {\n    padding: 12px;\n  }\n\n  .schoolStructure-content--forms {\n    padding: 0;\n  }\n}\n.schoolStructure-listActions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.schoolStructure-primaryActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.schoolStructure-btn {\n  min-height: 36px;\n  padding: 0 13px;\n  border-radius: var(--radius-md, 8px);\n  border: 1px solid var(--border-default, #cbd5e1);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: none;\n  cursor: pointer;\n  box-shadow: none;\n}\n\n.schoolStructure-btn:disabled {\n  opacity: 0.48;\n  cursor: default;\n}\n\n.schoolStructure-btn--primary {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.schoolStructure-btn--primary:hover:not(:disabled) {\n  border-color: var(--action-primary-hover, #1a6da3);\n  background: var(--action-primary-hover, #1a6da3);\n}\n\n.schoolStructure-btn--secondary {\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n}\n\n.schoolStructure-btn--secondary:hover:not(:disabled) {\n  border-color: var(--border-strong, #94a3b8);\n  background: var(--surface-hover, #f8fafc);\n}\n\n.schoolStructure-btn--danger {\n  border-color: transparent;\n  background: var(--red-500, #da4453);\n  color: #fff;\n}\n\n.schoolStructure-btn--danger:hover:not(:disabled) {\n  background: var(--red-600, #c4313f);\n  box-shadow: 0 4px 12px rgba(218, 68, 83, 0.28);\n}\n\n.schoolStructure-selection {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 12px;\n  flex-wrap: wrap;\n  min-height: 0;\n  padding: 8px 14px;\n  border: 1px solid var(--blue-100, #d4e8f6);\n  border-radius: var(--radius-md, 8px);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: var(--text-sm, 13px);\n}\n\n.schoolStructure-selection__summary {\n  display: inline-flex;\n  align-items: center;\n  flex: 0 0 auto;\n  color: var(--blue-700, #155d8c);\n  font-size: var(--text-sm, 13px);\n  font-weight: var(--weight-semibold, 600);\n  white-space: nowrap;\n}\n\n.schoolStructure-selection__actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.schoolStructure-selection .schoolStructure-btn {\n  min-height: var(--control-h-sm, 32px);\n  height: var(--control-h-sm, 32px);\n  padding: 0 11px;\n  font-size: var(--text-sm, 13px);\n  font-weight: var(--weight-semibold, 600);\n}\n\n.schoolStructure-selection__clear {\n  border: none;\n  background: transparent;\n  color: var(--text-link, #1a6da3);\n  padding: 0;\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: var(--text-sm, 13px);\n  font-weight: var(--weight-semibold, 600);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.schoolStructure-selection__clear:hover {\n  text-decoration: underline;\n}\n\n.schoolStructure-content .bActionsButton {\n  display: none !important;\n}\n\n@media (max-width: 560px) {\n  .schoolStructure-primaryActions,\n  .schoolStructure-selection,\n  .schoolStructure-selection__actions,\n  .schoolStructure-btn {\n    width: 100%;\n  }\n}\n\n.schoolStructure-drawerScrim {\n  position: fixed;\n  inset: 0;\n  z-index: 1040;\n  background: rgba(15, 23, 42, 0.28);\n}\n\n.schoolStructure-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 1041;\n  display: flex;\n  flex-direction: column;\n  width: min(520px, calc(100vw - 32px));\n  height: 100vh;\n  background: var(--surface-card, #fff);\n  border-left: 1px solid var(--border-subtle, #e2e8f0);\n  box-shadow: -18px 0 36px rgba(15, 23, 42, 0.18);\n}\n\n.schoolStructure-drawer--wide {\n  width: min(760px, calc(100vw - 32px));\n}\n\n.schoolStructure-drawer__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 22px 24px 18px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.schoolStructure-drawer__eyebrow {\n  margin-bottom: 5px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.schoolStructure-drawer__head h2 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-size: 22px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.schoolStructure-drawer__head p {\n  margin: 6px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.schoolStructure-drawer__close {\n  width: 34px;\n  height: 34px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-sm, 6px);\n  background: var(--surface-card, #fff);\n  color: var(--text-muted, #64748b);\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.schoolStructure-drawer__close:hover {\n  color: var(--text-strong, #0f172a);\n  background: var(--surface-hover, #f8fafc);\n}\n\n.schoolStructure-drawer__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: auto;\n  padding: 20px 24px 24px;\n}\n\n.schoolStructure-drawer__body .container-fluid,\n.schoolStructure-drawer__body .row,\n.schoolStructure-drawer__body .col-md-12 {\n  padding-left: 0;\n  padding-right: 0;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.schoolStructure-drawer__body label {\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.schoolStructure-content tbody tr {\n  cursor: pointer;\n}\n\n@media (max-width: 560px) {\n  .schoolStructure-drawer,\n  .schoolStructure-drawer--wide {\n    width: 100vw;\n  }\n\n  .schoolStructure-drawer__head {\n    padding: 18px 16px 14px;\n  }\n\n  .schoolStructure-drawer__body {\n    padding: 16px;\n  }\n}\n\n.schoolStructure-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 14px;\n}\n\n.schoolStructure-toolbar__heading {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.schoolStructure-toolbar__heading h2 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, inherit);\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: 0;\n  line-height: 1.2;\n}\n\n.schoolStructure-toolbar__heading span {\n  min-width: 24px;\n  height: 24px;\n  padding: 0 8px;\n  border-radius: var(--radius-pill, 999px);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.schoolStructure-toolbar__controls {\n  display: flex;\n  align-items: end;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.schoolStructure-toolbar__spacer {\n  flex: 1 1 auto;\n}\n\n.schoolStructure-search {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin: 0;\n}\n\n.schoolStructure-search span {\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.schoolStructure-search input {\n  width: 240px;\n  height: var(--control-h-md, 40px);\n  min-width: 0;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  color: var(--text-strong, #0f172a);\n  padding: 0 12px;\n  font-size: 13px;\n  box-shadow: none;\n}\n\n.schoolStructure-search input:focus {\n  outline: none;\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.12);\n}\n\n.schoolStructure-btn--active {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.schoolStructure-buttonIcon {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  display: inline-block;\n  background: currentColor;\n  mask-repeat: no-repeat;\n  mask-position: center;\n  mask-size: 16px 16px;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  -webkit-mask-size: 16px 16px;\n}\n\n.schoolStructure-buttonIcon--filter {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E\");\n}\n\n.schoolStructure-filterBtn {\n  min-height: var(--control-h-md, 40px);\n  height: var(--control-h-md, 40px);\n  padding-left: 11px;\n}\n\n.schoolStructure-clearFilters {\n  min-height: var(--control-h-md, 40px);\n  padding: 0 6px;\n  border: 0;\n  background: transparent;\n  color: var(--text-link, #1a6da3);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.schoolStructure-clearFilters:hover {\n  text-decoration: underline;\n}\n\n.schoolStructure-selectMenu {\n  position: relative;\n}\n\n.schoolStructure-selectMenu__menu {\n  right: 0;\n  left: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.schoolStructure-tableCard {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));\n}\n\n.schoolStructure-tableScroll {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.schoolStructure-table {\n  width: 100%;\n  min-width: 720px;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.schoolStructure-table th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  padding: 11px 14px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--slate-50, #f8fafc);\n  color: var(--text-muted, #64748b);\n  text-align: left;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.schoolStructure-table td {\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  vertical-align: middle;\n}\n\n.schoolStructure-table tbody tr {\n  cursor: pointer;\n  transition: background 0.12s ease;\n}\n\n.schoolStructure-table tbody tr:hover,\n.schoolStructure-table tbody tr[data-preview='true'] {\n  background: var(--slate-50, #f8fafc);\n}\n\n.schoolStructure-table tbody tr[data-selected='true'] {\n  background: var(--blue-50, #eef6fc);\n}\n\n.schoolStructure-table tbody tr[data-preview='true'] td:first-child {\n  box-shadow: inset 3px 0 0 var(--action-primary, #227ebd);\n}\n\n.schoolStructure-table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.schoolStructure-table__check {\n  width: 42px;\n  padding-right: 4px !important;\n}\n\n.schoolStructure-table__check input,\n.schoolStructure-cardCheck input {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  accent-color: var(--action-primary, #227ebd);\n}\n\n.schoolStructure-table__sortable {\n  cursor: pointer;\n}\n\n.schoolStructure-rowTitle {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--text-strong, #0f172a);\n  font-weight: 700;\n}\n\n.schoolStructure-formIcon {\n  width: 34px;\n  height: 34px;\n  border-radius: 9px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 17px;\n  line-height: 1;\n}\n\n.schoolStructure-formIcon::before {\n  content: '';\n  width: 17px;\n  height: 17px;\n  background: currentColor;\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9m-6-6 6 6m-6-6v6h6M8 13h8M8 17h6' fill='none' stroke='black' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  mask-position: center;\n  mask-repeat: no-repeat;\n  mask-size: contain;\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9m-6-6 6 6m-6-6v6h6M8 13h8M8 17h6' fill='none' stroke='black' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  -webkit-mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-size: contain;\n}\n\n.schoolStructure-badge {\n  min-height: 24px;\n  padding: 0 9px;\n  border-radius: var(--radius-pill, 999px);\n  display: inline-flex;\n  align-items: center;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.schoolStructure-mutedText {\n  color: var(--text-muted, #64748b);\n}\n\n.schoolStructure-empty {\n  height: 132px;\n  text-align: center;\n  color: var(--text-muted, #64748b);\n}\n\n.schoolStructure-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 12px;\n}\n\n.schoolStructure-pagination__summary {\n  margin-right: 4px;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.schoolStructure-pagination__ellipsis {\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n}\n\n.schoolStructure-pageBtn {\n  min-width: 34px;\n  height: 34px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-sm, 6px);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.schoolStructure-pageBtn--active {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.schoolStructure-houseGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(268px, 1fr));\n  gap: 16px;\n}\n\n.schoolStructure-houseCard {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));\n  cursor: pointer;\n  transition: box-shadow 0.15s ease, transform 0.15s ease, border-color 0.15s ease;\n}\n\n.schoolStructure-houseCard:hover,\n.schoolStructure-houseCard[data-preview='true'] {\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.12);\n  transform: translateY(-2px);\n}\n\n.schoolStructure-houseCard[data-selected='true'] {\n  border-color: var(--blue-200, #b7dbf2);\n  background: var(--blue-50, #eef6fc);\n}\n\n.schoolStructure-houseCard__stripe {\n  height: 6px;\n}\n\n.schoolStructure-houseCard__body {\n  padding: 18px 18px 16px;\n}\n\n.schoolStructure-houseCard__top {\n  display: flex;\n  align-items: center;\n  gap: 13px;\n}\n\n.schoolStructure-houseCard__title {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.schoolStructure-houseCard__title h3 {\n  margin: 0 0 5px;\n  color: var(--text-strong, #0f172a);\n  font-size: 17px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.schoolStructure-houseCard p {\n  min-height: 42px;\n  margin: 13px 0 16px;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  line-height: 1.55;\n}\n\n.schoolStructure-houseCrest {\n  flex: 0 0 auto;\n  border-radius: 50%;\n  object-fit: cover;\n  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.08);\n}\n\n.schoolStructure-houseCrest--initial {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-weight: 800;\n  font-size: 18px;\n  text-transform: uppercase;\n}\n\n.schoolStructure-colours {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.schoolStructure-colours i {\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.12);\n}\n\n.schoolStructure-cardCheck {\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.schoolStructure-houseCard__stats {\n  display: flex;\n  gap: 20px;\n  padding-top: 14px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.schoolStructure-houseCard__stats div {\n  min-width: 0;\n}\n\n.schoolStructure-houseCard__stats strong {\n  display: block;\n  color: var(--text-strong, #0f172a);\n  font-size: 19px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.schoolStructure-houseCard__stats span {\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n}\n\n.schoolStructure-emptyCard {\n  padding: 40px 20px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #fff);\n  text-align: center;\n}\n\n.schoolStructure-emptyCard__icon {\n  width: 46px;\n  height: 46px;\n  margin: 0 auto 12px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 22px;\n}\n\n.schoolStructure-emptyCard__icon::before {\n  content: '';\n  width: 22px;\n  height: 22px;\n  background: currentColor;\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m3 11 9-7 9 7M5 10v10h14V10M9 20v-6h6v6' fill='none' stroke='black' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  mask-position: center;\n  mask-repeat: no-repeat;\n  mask-size: contain;\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m3 11 9-7 9 7M5 10v10h14V10M9 20v-6h6v6' fill='none' stroke='black' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  -webkit-mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-size: contain;\n}\n\n.schoolStructure-emptyCard h3 {\n  margin: 0 0 6px;\n  color: var(--text-strong, #0f172a);\n  font-size: 17px;\n  font-weight: 800;\n}\n\n.schoolStructure-emptyCard p {\n  margin: 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n}\n\n@media (max-width: 760px) {\n  .schoolStructure-toolbar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .schoolStructure-toolbar__controls,\n  .schoolStructure-search,\n  .schoolStructure-search input {\n    width: 100%;\n  }\n\n  .schoolStructure-toolbar__controls .schoolStructure-btn,\n  .schoolStructure-selectMenu {\n    width: 100%;\n  }\n\n  .schoolStructure-pagination {\n    justify-content: flex-start;\n  }\n}\n\n.schoolStructure-overview {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(140px, 1fr));\n  gap: 12px;\n  margin: 0 0 14px;\n}\n\n.schoolStructure-overviewCard {\n  min-height: 76px;\n  padding: 14px 16px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-xs, 0 1px 2px rgba(15, 23, 42, 0.06));\n}\n\n.schoolStructure-overviewCard--primary {\n  border-color: var(--blue-100, #d4e8f6);\n  background: linear-gradient(180deg, var(--blue-50, #eef6fc) 0%, var(--surface-card, #fff) 100%);\n}\n\n.schoolStructure-overviewCard span {\n  display: block;\n  margin-bottom: 7px;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.schoolStructure-overviewCard strong {\n  display: block;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, inherit);\n  font-size: 24px;\n  font-weight: 800;\n  line-height: 1.1;\n}\n\n.schoolStructure-rowTitle__text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.schoolStructure-rowTitle__text strong {\n  color: var(--text-strong, #0f172a);\n  font-size: 13.5px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.schoolStructure-rowTitle__text small {\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n  font-weight: 600;\n  line-height: 1.25;\n}\n\n.schoolStructure-countPill {\n  min-height: 26px;\n  padding: 0 10px;\n  border: 1px solid var(--green-200, #b9e7d0);\n  border-radius: var(--radius-pill, 999px);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--green-50, #ecfdf3);\n  color: var(--green-700, #16794a);\n  font-size: 12px;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.schoolStructure-countPill--muted {\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--slate-50, #f8fafc);\n  color: var(--text-muted, #64748b);\n}\n\n.schoolStructure-badge--age {\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--slate-0, #fff);\n}\n\n.schoolStructure-drawer--form {\n  width: min(560px, calc(100vw - 32px));\n}\n\n.schoolStructure-drawer__head--rich {\n  align-items: flex-start;\n  background: linear-gradient(180deg, var(--slate-25, #f8fafc) 0%, var(--surface-card, #fff) 100%);\n}\n\n.schoolStructure-drawer__leadIcon {\n  flex: 0 0 auto;\n  margin-top: 2px;\n}\n\n.schoolStructure-drawer__leadIcon .schoolStructure-formIcon {\n  width: 44px;\n  height: 44px;\n  border-radius: var(--radius-md, 8px);\n  background: var(--blue-50, #eef6fc);\n  color: var(--action-primary, #227ebd);\n  font-size: 20px;\n  box-shadow: inset 0 0 0 1px var(--blue-100, #d4e8f6);\n}\n\n.schoolStructure-detailStats {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.schoolStructure-detailStat {\n  min-height: 74px;\n  padding: 12px 14px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-md, 8px);\n  background: var(--slate-25, #f8fafc);\n}\n\n.schoolStructure-detailStat span {\n  display: block;\n  margin-bottom: 7px;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.schoolStructure-detailStat strong {\n  display: block;\n  color: var(--text-strong, #0f172a);\n  font-size: 17px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.schoolStructure-formPanel {\n  padding: 16px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-xs, 0 1px 2px rgba(15, 23, 42, 0.06));\n}\n\n.schoolStructure-formPanel__title {\n  margin-bottom: 14px;\n  color: var(--text-strong, #0f172a);\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.schoolFormForm--ds {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.schoolFormForm__grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n}\n\n.schoolFormForm__field {\n  margin: 0;\n}\n\n.schoolFormForm__field label {\n  display: block;\n  margin: 0 0 4px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.03em;\n  text-transform: none;\n}\n\n.schoolFormForm__field .form-control {\n  height: 36px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n  box-shadow: none;\n}\n\n.schoolFormForm__field .form-control:focus {\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.12);\n}\n\n.schoolFormForm__ageGroups {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 7px;\n  padding: 7px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n}\n\n.schoolFormForm__ageGroups.is-invalid {\n  border-color: var(--danger, #dc3545);\n}\n\n.schoolFormForm__ageSection {\n  min-width: 0;\n  padding: 6px;\n  border-radius: var(--radius-sm, 6px);\n  background: var(--slate-50, #f8fafc);\n}\n\n.schoolFormForm__ageSection > strong {\n  display: block;\n  margin-bottom: 5px;\n  color: var(--text-muted, #64748b);\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  line-height: 1.2;\n  text-transform: uppercase;\n}\n\n.schoolFormForm__ageChips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.schoolFormForm__ageChip {\n  min-height: 27px;\n  padding: 3px 9px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 999px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.schoolFormForm__ageChip:hover {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--surface-hover, #f8fafc);\n}\n\n.schoolFormForm__ageChip--selected {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n  box-shadow: none;\n}\n\n.schoolFormForm__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding-top: 0;\n}\n\n.schoolStructure-modal--form .modal-header {\n  padding: 12px 16px !important;\n}\n\n.schoolStructure-modal--form .modal-body {\n  padding: 14px 16px !important;\n}\n\n@media (max-width: 760px) {\n  .schoolStructure-overview {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 520px) {\n  .schoolStructure-overview,\n  .schoolStructure-detailStats {\n    grid-template-columns: 1fr;\n  }\n\n  .schoolFormForm__actions {\n    flex-direction: column-reverse;\n  }\n\n  .schoolFormForm__ageGroups {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .schoolFormForm__actions .schoolStructure-btn {\n    width: 100%;\n  }\n}\n\n.schoolStructure-toolbar--inlineFilters {\n  align-items: flex-start;\n}\n\n.schoolStructure-toolbar__titleControls {\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.schoolStructure-filterCount {\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--brand-100, #d9eefb);\n  color: var(--brand-700, #17679e);\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.schoolStructure-drawer--filters {\n  width: min(440px, calc(100vw - 32px));\n}\n\n.schoolStructure-filterFooter {\n  justify-content: space-between;\n}\n\n.schoolStructure-filterSections {\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n}\n\n.schoolStructure-filterSections .people-chipFilter + .people-chipFilter {\n  padding-top: 18px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n/* The drawer body owns vertical scrolling. Filter option groups must expand in\n   normal document flow so users never get a scrollbar inside a scrollbar. */\n.schoolStructure-filterSections .people-chipFilter__body {\n  max-height: none;\n  overflow: visible;\n}\n\n.schoolStructure-content .people-filterChips {\n  display: flex;\n  min-height: 43px;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin: -2px 0 14px;\n  padding: 8px 12px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n}\n\n.schoolStructure-content .people-filterChips > span {\n  display: inline-flex;\n  min-height: 28px;\n  align-items: center;\n  gap: 4px;\n  padding: 0 9px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 12px;\n}\n\n.schoolStructure-content .people-filterChips > span b {\n  font-weight: 800;\n}\n\n.schoolStructure-content .people-filterChips > span button,\n.schoolStructure-content .people-filterChips__clear {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.schoolStructure-content .people-filterChips > span button {\n  margin-left: 3px;\n  font-size: 16px;\n  line-height: 1;\n}\n\n.schoolStructure-content .people-filterChips__clear {\n  margin-left: 2px;\n  color: var(--blue-700, #155d8c);\n  font-size: 12px;\n}\n\n.schoolStructure-search--compact input {\n  width: 210px;\n}\n\n.schoolStructure-formPanel__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.schoolStructure-formPanel__header .schoolStructure-formPanel__title {\n  margin-bottom: 0;\n}\n\n.schoolStructure-warningModal {\n  display: flex;\n  gap: 11px;\n  align-items: flex-start;\n  white-space: normal;\n}\n\n.schoolStructure-warningModal__icon {\n  flex: 0 0 auto;\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-sm, 6px);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--amber-50, #fffbeb);\n  color: var(--amber-700, #a16207);\n  font-size: 15px;\n  font-weight: 900;\n  box-shadow: inset 0 0 0 1px var(--amber-200, #fde68a);\n}\n\n.schoolStructure-warningModal--danger .schoolStructure-warningModal__icon {\n  background: var(--red-50, #fff1f2);\n  color: var(--red-600, #c4313f);\n  box-shadow: inset 0 0 0 1px var(--red-100, #ffd5da);\n}\n\n.schoolStructure-warningModal h3 {\n  margin: 0 0 6px;\n  color: var(--text-strong, #0f172a);\n  font-size: 16px;\n  font-weight: 800;\n}\n\n.schoolStructure-warningModal p {\n  margin: 0;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.45;\n}\n\n.schoolStructure-modal--warning .modal-header {\n  padding: 13px 16px !important;\n}\n\n.schoolStructure-modal--warning .modal-header button {\n  width: 32px !important;\n  height: 32px !important;\n  border-radius: 8px !important;\n}\n\n.schoolStructure-modal--warning .modal-body {\n  padding: 15px 16px !important;\n}\n\n.schoolStructure-modal--warning .modal-footer {\n  padding: 10px 16px !important;\n}\n\n.schoolStructure-modal--warning .modal-footer .btn {\n  min-height: 34px !important;\n  padding: 0 13px !important;\n  border-radius: var(--radius-md, 8px) !important;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.schoolStructure-modal--danger .modal-footer .btn-primary {\n  border-color: var(--red-500, #da4453) !important;\n  background: var(--red-500, #da4453) !important;\n  color: #fff !important;\n}\n\n.schoolStructure-modal--danger .modal-footer .btn-primary:hover {\n  border-color: var(--red-600, #c4313f) !important;\n  background: var(--red-600, #c4313f) !important;\n}\n\n.schoolStructure-drawer--house {\n  width: min(560px, calc(100vw - 32px));\n}\n\n.schoolStructure-drawer__footer {\n  display: flex;\n  gap: 10px;\n  padding: 14px 22px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--slate-25, #f8fafc);\n}\n\n.schoolStructure-drawer__footer .schoolStructure-btn {\n  flex: 1 1 auto;\n}\n\n.houseFormDs {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.houseFormDs__crestBlock {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.houseFormDs__crest {\n  width: 82px;\n  height: 82px;\n  border-radius: var(--radius-lg, 12px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: var(--slate-50, #f8fafc);\n  box-shadow: inset 0 0 0 1px var(--border-subtle, #e2e8f0);\n}\n\n.houseFormDs__crest img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.houseFormDs__crest span {\n  color: var(--text-muted, #64748b);\n  font-size: 28px;\n  font-weight: 800;\n}\n\n.houseFormDs__crestActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.houseFormDs__file {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.houseFormDs__textarea {\n  min-height: 88px;\n  padding-top: 10px;\n  resize: vertical;\n}\n\n.houseFormDs__colours {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  padding: 16px 0;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.houseFormDs__label {\n  margin-bottom: 8px;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.houseFormDs__swatches {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.houseFormDs__swatch {\n  width: 34px;\n  height: 34px;\n  border-radius: var(--radius-md, 8px);\n  border: 2px solid transparent;\n  cursor: pointer;\n  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.16);\n}\n\n.houseFormDs__swatch--selected {\n  border-color: var(--text-strong, #0f172a);\n}\n\n.houseFormDs__customColour {\n  height: 34px;\n  padding: 0 8px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.houseFormDs__customColour input {\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n}\n\n@media (max-width: 760px) {\n  .schoolStructure-toolbar__titleControls,\n  .schoolStructure-toolbar__titleControls .schoolStructure-search,\n  .schoolStructure-search--compact input {\n    width: 100%;\n  }\n\n  .houseFormDs__colours {\n    grid-template-columns: 1fr;\n  }\n\n  .schoolStructure-drawer__footer {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
